var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Activar Firma Simple - Signapis")]),
    _vm._m(0),
    _c(
      "form",
      {
        attrs: { autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.save($event)
          }
        }
      },
      [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-lg-8 col-md-10" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("p", [
                      _c("strong", [_vm._v("Usuario:")]),
                      _vm._v(" " + _vm._s(_vm.user.nombre))
                    ]),
                    _c("p", [
                      _c("strong", [_vm._v("Correo:")]),
                      _vm._v(" " + _vm._s(_vm.user.correo))
                    ])
                  ]),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("p", [
                      _c("strong", [_vm._v("RUT:")]),
                      _vm._v(" " + _vm._s(_vm.user.iut))
                    ]),
                    _vm._m(1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "row mt-3 justify-content-center" }, [
          _c("div", { staticClass: "col-lg-8 col-md-10 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit", disabled: _vm.saving }
              },
              [
                _vm.saving
                  ? _c("b-spinner", { attrs: { small: "", variant: "light" } })
                  : _c("span", [_vm._v("Activar firma")])
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-info mb-3" }, [
      _c("p", [
        _vm._v(" La firma electrónica simple con "),
        _c("b", [_vm._v("Signapis")]),
        _vm._v(
          " no requiere enrolamiento interno. El usuario debe estar registrado directamente en la plataforma de Signapis. "
        )
      ]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          " Al activar esta configuración, se habilitará al usuario para firmar documentos electrónicamente a través de Signapis. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Proveedor:")]),
      _vm._v(" Signapis (Firma Electrónica)")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }